// extracted by mini-css-extract-plugin
export default {"rating":"vy-z","numberOfStars":"wy-z","count":"xy-z","barGraphSpacing":"yy-z","barGraph":"zy-z"};